import { startTransition, StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';
import { detectLang, loadLanguage } from './i18n.js';

loadLanguage(detectLang(window.location.pathname)).then(
    () =>
        startTransition(() => {
            hydrateRoot(
                document,
                <StrictMode>
                    <HydratedRouter />
                </StrictMode>,
            );
        }),
    (error) => console.error('Could not load the page language; the page stays as prerendered', error),
);
